import styles from './PSD2ConnectionSuccessPage.module.css';
import { Card } from '../../../../../organisms/card';
import Text from '../../../../../atoms/typography/Text';
import { ColorEnum, FontSizeEnum, FontWeightEnum } from '../../../../../enums';
import React from 'react';
import { useTranslation} from 'react-i18next';
import screeningSteps, { Action } from '../../../../../organisms/screening-navigation/screeningSteps';
import CheckboxCircleFillIcon from '../../../../../atoms/icons/CheckboxCircleFillIcon';
import Divider from '../../../../../atoms/divider';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useRoutePath } from '../../../../../utils/useRoutePath';
import { classNames } from '../../../../../utils';
import ScreeningNavigation from '../../../../../organisms/screening-navigation/ScreeningNavigation';
import PageContentNotFound from '../../../../../organisms/page-content-not-found/PageContentNotFound';

const PSD2ConnectionSuccessPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const routePath = useRoutePath();
    const { homeseekerId } = useParams();
    const [ searchParams ] = useSearchParams();

    const authorisationId = searchParams.get('authorisationId');

    const handleClick = (action: Action) => {
        if (action === 'next') {
            navigate(routePath('ScreeningAdditionalInformation', { homeseekerId }, { authorisationId }));
        }
    }

    if (!authorisationId) {
        return <PageContentNotFound/>;
    }

    return (
        <div className={styles.contentContainer}>
            <div className={styles.gridLg}>
                <Text
                    color={ColorEnum.Primary700}
                    weight={FontWeightEnum.Bold}
                    size={FontSizeEnum.DisplayXs}
                >{t(screeningSteps.ScreeningIncomeVerificationProvideTransactionsPsd2ConnectionSuccessPage.pageTitleTranslationKey)}</Text>
                <Card elevated>
                    <div className={styles.gridMd}>
                        <div className={styles.iconContainer}>
                            <CheckboxCircleFillIcon className={styles.checkboxIcon} />
                        </div>
                        <Text
                            className={styles.textCenter}
                            size={FontSizeEnum.DisplayXs}
                            weight={FontWeightEnum.Bold}
                            color={ColorEnum.Primary700}
                        >{t('screening.incomeVerification.provideTransactions.psd2ConnectionSuccessPage.header')}</Text>
                        <Divider />
                        <div className={classNames(styles.textLeft, styles.gridMd)}>
                            <Text
                                color={ColorEnum.Gray800}
                            >{t('screening.incomeVerification.provideTransactions.psd2ConnectionSuccessPage.text')}</Text>
                        </div>
                    </div>
                </Card>
                <ScreeningNavigation
                    onClick={handleClick}
                />
            </div>
        </div>
    );
}

export default PSD2ConnectionSuccessPage;
